// extracted by mini-css-extract-plugin
export default {"HighlightedText":"HighlightedText-module__HighlightedText--XiJMv"};